import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('dental_benefits_set_review', '/dental_benefits_set_reviews', 'review')
const actions = generator.generate()

export default actions
